import React, { useContext, useEffect, useState } from 'react'
import { firestore } from '../../../firebase';
import StateContext from '../../../StateContext';
import SingleQuizQuestion from './SingleQuizQuestion';

function QuizQuestions({id, mode}) {

    const appState = useContext(StateContext);

    const [questions, setQuestions] = useState([]);
    const [name, setName] = useState("");
    const [error, setError] = useState("");
    const [message, setMessage] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false)

    const [correctAmount, setCorrectAmount] = useState(0);
    const [answeredAmount, setAnsweredAmount] = useState(0)

    const [show, setShow] = useState(true);

    useEffect(() => {

        try {
            const questionsRef = firestore.collection("quiz").doc(id).collection("questions");
            questionsRef.orderBy("number").onSnapshot(({docs}) => {
                const questions = docs.map(doc => {
                    return {id: doc.id, ...doc.data()}
                });
                setQuestions(questions);
            })
        } catch (error) {
            
        }

    }, [id])

    async function submitHandler(e) {
        e.preventDefault();
        try {
            const answersRef = firestore.collection("quiz").doc(id).collection("answers");
            
            const score = correctAmount;
            const percentage = (correctAmount/questions.length)*100

            let userData;

            if (appState.loggedIn) {
                userData = appState.userId
            } else {
                userData = "anonym";
            }
            
            const data = {
                name,
                score,
                percentage,
                user: userData,
                name
            }
            answersRef.add(data);

            setMessage("Lagret!")
            setIsSubmitted(true)
            setShow(false)
        } catch (error) {
            setError("Kunne ikke lagre poengsum")
        }
    }

    function resetQuiz() {
        setIsSubmitted(false);
        setShow(true);
        setError("");
        setMessage("")
    }

    return (
        <div>
            {show && (
                <React.Fragment>
                    {questions.map((question, index) => {
                        return  (
                            <SingleQuizQuestion 
                                key={index} 
                                index={index}
                                question={question} 
                                quizId={id} 
                                correctAmount={correctAmount}
                                setCorrectAmount={setCorrectAmount} 
                                isSubmitted={isSubmitted}
                                mode={mode}
                                answeredAmount={answeredAmount}
                                setAnsweredAmount={setAnsweredAmount}
                            />
                        )
                    })}
                </React.Fragment>
            )}


            
            {isSubmitted && (
                <div>
                    <h2 className="text-center font-weight-bold my-4">
                        Du fikk 
                        <span 
                        className={correctAmount === questions.length ? "text-success" : correctAmount < (questions.length/2 ? "text-danger" : "text-warning")}> {correctAmount} av</span> <span className="text-success">{questions.length}</span>  riktige!</h2>
                    <button onClick={resetQuiz} className="btn btn-block btn-success">Ta test på nytt <i className="fas fa-redo-alt"></i></button>
                </div>
            )}
            {!isSubmitted && (
                <React.Fragment>

                    <p>Du har svart på <span className={answeredAmount === questions.length ? "text-success font-weight-bold" : "text-danger font-weight-bold"}>{answeredAmount}</span> av {questions.length} spørsmål</p>

                    {!appState.loggedIn ? <div className="alert alert-danger my-4">Logg inn for å lagre din score i topplisten</div> : 
                        <div className="form-group my-4">
                            <label>Ditt navn</label>
                            <input className="form-control mb-2" value={name} onChange={e => setName(e.target.value)} placeholder="Ditt navn" />
                        </div>
                    }

                    {message && <div className="alert alert-success">{message} <span onClick={() => setMessage("")} className="float-right">Lukk</span></div>}
                    {error && <div className="alert alert-danger">{error}</div>}
                    {answeredAmount !== questions.length && answeredAmount > 0 && <div className="alert alert-danger">Du har ikke svart på alle spørsmålene</div>}
                    {answeredAmount === questions.length && <div className="alert alert-success">Du har svart på alle spørsmålene. Trykk på "Lagre svar" for å avslutte quiz og se svarene.</div>}
                    <button disabled={isSubmitted} onClick={submitHandler} className="btn btn-success btn-block">Lagre svar</button>
                </React.Fragment>
            )}

        </div>
    )

}
export default QuizQuestions